import React from 'react';
import Back from 'common/Back';
import UpgradePurchase from 'billing/purchases/UpgradePurchase/sprint';
import add_data from 'common/img/add_data.svg';
import { sprintAddData } from 'app/routes';
import styles from './AddDataPurchase.module.css';

const AddDataPurchase = ({ subId, planId }) => {
  return (
    <div className={styles.UpgradePurchase}>
      <div className={styles.Back}>
        <Back to={sprintAddData(subId)} />
      </div>
      <h1>
        Add Data
        <img src={add_data} alt="" />
      </h1>
      <UpgradePurchase sprintSubId={subId} planId={planId} />
    </div>
  );
}

export default AddDataPurchase;
